import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';

interface IStickerCategoryProps {
  iconUrl: string;
  displayName: string;
  stickersCount: number;
}
export const StickerCategory: FC<IStickerCategoryProps> = ({
  iconUrl,
  displayName,
  stickersCount,
}) => {
  const { t } = useTranslation();

  return (
    <div className={popupItemStyles.container}>
      <PopupInfoCard
        type={AvatarTypes.Round_10}
        avatarTitle={displayName}
        avatarUrl={iconUrl}
        avatarBackgroundColorIndex="1"
        title={displayName}
        subtitle={t('amount_of_stickers_in_a_pack_few', { 0: stickersCount })}
      />
    </div>
  );
};
